/**
 * @flow
 * @relayHash bcc510d3b842b5e0f081285aa190b66f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ApplicationType = "MAIN_APP" | "OPERATOR_PORTAL";
export type FormFieldType = "CHECKBOX" | "DATE" | "MULTILINE_TEXT" | "MULTISELECT" | "NUMBER" | "SELECT" | "SELECT_CUSTOMER" | "SELECT_MACHINE" | "SELECT_ORDER" | "SELECT_USER" | "TEXT";
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type UpdateFormFieldInput = {|
  id: string,
  name?: ?string,
  description?: ?string,
  placeholder?: ?string,
  type?: ?FormFieldType,
  isCreatable?: ?boolean,
  displayOrder?: ?number,
  properties?: ?any,
  options?: ?$ReadOnlyArray<string>,
|};
export type UpdateFormFieldMutationVariables = {|
  input: UpdateFormFieldInput
|};
export type UpdateFormFieldMutationResponse = {|
  +updateFormField: {|
    +form: {|
      +id: string,
      +name: string,
      +type: FormType,
      +description: ?string,
      +displayOrder: number,
      +isTemplate: boolean,
      +updatedAt: any,
      +createdAt: any,
      +fields: $ReadOnlyArray<{|
        +id: string,
        +type: FormFieldType,
        +name: string,
        +description: ?string,
        +applicationType: ApplicationType,
        +placeholder: ?string,
        +displayOrder: number,
        +systemKey: ?string,
        +isRequired: boolean,
        +updatedAt: any,
        +createdAt: any,
        +isCreatable: boolean,
        +properties: ?any,
        +options: $ReadOnlyArray<{|
          +id: string,
          +name: string,
          +value: string,
        |}>,
      |}>,
    |}
  |}
|};
export type UpdateFormFieldMutation = {|
  variables: UpdateFormFieldMutationVariables,
  response: UpdateFormFieldMutationResponse,
|};
*/


/*
mutation UpdateFormFieldMutation(
  $input: UpdateFormFieldInput!
) {
  updateFormField(input: $input) {
    form {
      id
      name
      type
      description
      displayOrder
      isTemplate
      updatedAt
      createdAt
      fields {
        id
        type
        name
        description
        applicationType
        placeholder
        displayOrder
        systemKey
        isRequired
        updatedAt
        createdAt
        isCreatable
        properties
        options {
          id
          name
          value
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormFieldInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayOrder",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFormField",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFormFieldPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "form",
        "storageKey": null,
        "args": null,
        "concreteType": "Form",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isTemplate",
            "args": null,
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "fields",
            "storageKey": null,
            "args": null,
            "concreteType": "FormField",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "applicationType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "placeholder",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "systemKey",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isRequired",
                "args": null,
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCreatable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "properties",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "options",
                "storageKey": null,
                "args": null,
                "concreteType": "FormFieldOption",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "value",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateFormFieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v8/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateFormFieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v8/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateFormFieldMutation",
    "id": null,
    "text": "mutation UpdateFormFieldMutation(\n  $input: UpdateFormFieldInput!\n) {\n  updateFormField(input: $input) {\n    form {\n      id\n      name\n      type\n      description\n      displayOrder\n      isTemplate\n      updatedAt\n      createdAt\n      fields {\n        id\n        type\n        name\n        description\n        applicationType\n        placeholder\n        displayOrder\n        systemKey\n        isRequired\n        updatedAt\n        createdAt\n        isCreatable\n        properties\n        options {\n          id\n          name\n          value\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '53615adbb3f00e46026b5a3ec8f603a4';
module.exports = node;
